export default __webpack_public_path__ + "static/media/black-bird-without-logo.3b5eb7e4.svg";